var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNutritionDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2136",
    "data-name": "Grupo 2136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.571,
    height: 97.293,
    viewBox: "0 0 159.571 97.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1393",
    "data-name": "Ret\\xE2ngulo 1393",
    width: 159.571,
    height: 97.293,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2040",
    "data-name": "Grupo 2040",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1228",
    "data-name": "Caminho 1228",
    d: "M248.275,216.164H254L265.425,231v-12.1a2.3,2.3,0,0,0-2.317-2.421v-.309h5.768v.309a2.3,2.3,0,0,0-2.318,2.421v17.7h-1.572l-13.209-16.878v14.112c0,1.545.566,2.265,1.957,2.316h.36v.311h-5.768v-.311h.36c1.39-.052,1.957-.72,1.957-2.316V219.049a2.4,2.4,0,0,0-2.369-2.577Z",
    transform: "translate(-178.576 -155.48)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1229",
    "data-name": "Caminho 1229",
    d: "M345.031,216.166H325.924l-.412,4.481h.257s1.442-3.554,4.635-3.554H333.6v16.688c0,1.545-.566,2.318-1.957,2.369l-.36,0v.311h8.5v-.311l-.309,0c-1.39-.052-1.957-.773-1.957-2.369V217.145h3.09c3.142,0,4.635,3.554,4.635,3.554h.257Z",
    transform: "translate(-234.131 -155.481)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1230",
    "data-name": "Caminho 1230",
    d: "M140.2,230.076c0-3.24-2.532-5.012-6.684-6.987-3.24-1.519-4.2-2.38-4.2-3.9s1.165-2.582,3.038-2.886a6.243,6.243,0,0,1,2.379.152,5.376,5.376,0,0,1,3.8,3.544h.253v-3.342a11.706,11.706,0,0,0-5.975-1.418c-2.886,0-6.379,1.468-6.379,5.266a4.673,4.673,0,0,0,1.519,3.545c.709.709,1.57,1.519,4.962,3.19,3.544,1.671,4.506,2.582,4.506,4.253,0,2.886-2.684,3.595-4.455,3.595a6.74,6.74,0,0,1-6.532-3.848h-.3v3.392a15.17,15.17,0,0,0,6.886,1.418c3.19.051,7.19-2.126,7.19-5.974",
    transform: "translate(-90.718 -154.813)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1231",
    "data-name": "Caminho 1231",
    d: "M82.822,230.076c0-3.24-2.532-5.012-6.683-6.987-3.24-1.519-4.2-2.38-4.2-3.9s1.164-2.582,3.038-2.886a6.244,6.244,0,0,1,2.38.152,5.374,5.374,0,0,1,3.8,3.544H81.4v-3.342a11.706,11.706,0,0,0-5.975-1.418c-2.886,0-6.38,1.468-6.38,5.266a4.75,4.75,0,0,0,1.519,3.545c.709.709,1.57,1.519,4.962,3.19,3.544,1.671,4.506,2.582,4.506,4.253,0,2.886-2.684,3.595-4.506,3.595A6.741,6.741,0,0,1,69,231.24h-.3v3.392a15.169,15.169,0,0,0,6.886,1.418c3.24.051,7.24-2.126,7.24-5.974",
    transform: "translate(-49.411 -154.813)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1232",
    "data-name": "Caminho 1232",
    d: "M16.481,231.978s-1.648,3.554-5.356,3.554H6.232V226.21H9.837c3.5,0,3.76,2.627,3.76,2.627h.258v-5.871H13.6s-.257,2.317-3.76,2.317H6.232V217.2H10.97a4.69,4.69,0,0,1,4.738,3.5h.309v-4.532H0v.309a2.294,2.294,0,0,1,2.317,2.214v15.091A2.25,2.25,0,0,1,.309,236.15H0v.309H15.966l.773-4.48Z",
    transform: "translate(0 -155.481)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1233",
    "data-name": "Caminho 1233",
    d: "M454.244,235.752c-1.2-.046-1.883-.495-2.612-1.952l-8.344-18.18h-.979l-7,18.129a3.329,3.329,0,0,1-2.759,1.988v.33h6.519v-.309s-3.113-.174-2.112-2.833l1.442-3.863h7l1.905,4.326c.988,2.2-1.906,2.369-1.906,2.369l0,.309h8.842Zm-15.385-7.618,2.781-7.571,3.4,7.571Z",
    transform: "translate(-311.117 -155.088)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1234",
    "data-name": "Caminho 1234",
    d: "M526.589,231.877s-1.648,3.554-5.356,3.554h-4.378V218.9a2.3,2.3,0,0,1,2.318-2.421v-.309h-8.549v.309a2.27,2.27,0,0,1,2.266,2.421v14.781a2.253,2.253,0,0,1-2.046,2.454v.327h15.23l.773-4.532Z",
    transform: "translate(-367.275 -155.483)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1235",
    "data-name": "Caminho 1235",
    d: "M409.485,236.119a2.519,2.519,0,0,1-2.156-2.39V218.948a2.321,2.321,0,0,1,2.318-2.472v-.31H401.1v.31a2.321,2.321,0,0,1,2.318,2.472v14.781c0,2.075-2.318,2.421-2.318,2.421v.309h8.388Z",
    transform: "translate(-288.496 -155.481)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1236",
    "data-name": "Caminho 1236",
    d: "M198.527,231.978s-1.648,3.554-5.356,3.554h-4.893V226.21h3.605c3.5,0,3.76,2.627,3.76,2.627h.258v-5.871h-.258s-.257,2.317-3.76,2.317h-3.605V217.2h4.738a4.69,4.69,0,0,1,4.738,3.5h.309v-4.532H182.046v.309a2.294,2.294,0,0,1,2.317,2.214v15.091a2.25,2.25,0,0,1-2.009,2.369h-.309v.309h15.966l.773-4.48Z",
    transform: "translate(-130.94 -155.481)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1237",
    "data-name": "Caminho 1237",
    d: "M159.645,325.657l-4.405-6.112v6.112h-1.194v-7.963h1.23l4.334,5.969v-5.969H160.8v7.963Z",
    transform: "translate(-110.801 -228.507)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1238",
    "data-name": "Caminho 1238",
    d: "M190.28,317.694h1.206v4.811a2.145,2.145,0,1,0,4.286,0v-4.811h1.206v4.835a3.35,3.35,0,0,1-6.7.012Z",
    transform: "translate(-136.862 -228.507)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1239",
    "data-name": "Caminho 1239",
    d: "M226.946,325.657v-6.912h-2.471v-1.051H230.6v1.051h-2.459v6.912Z",
    transform: "translate(-161.457 -228.507)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1240",
    "data-name": "Caminho 1240",
    d: "M261.168,325.657l-1.9-3.068h-1.493v3.068h-1.193v-7.963h3.354a2.373,2.373,0,0,1,2.555,2.447,2.221,2.221,0,0,1-1.981,2.328l2.041,3.187Zm-1.385-6.913h-2.006v2.794h2.006a1.4,1.4,0,1,0,0-2.794",
    transform: "translate(-184.553 -228.507)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1391",
    "data-name": "Ret\\xE2ngulo 1391",
    width: 1.194,
    height: 7.963,
    transform: "translate(81.057 89.187)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1241",
    "data-name": "Caminho 1241",
    d: "M305.8,325.657v-6.912h-2.471v-1.051h6.124v1.051h-2.459v6.912Z",
    transform: "translate(-218.171 -228.507)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1392",
    "data-name": "Ret\\xE2ngulo 1392",
    width: 1.194,
    height: 7.963,
    transform: "translate(94.167 89.187)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1242",
    "data-name": "Caminho 1242",
    d: "M354.712,317.226a4.12,4.12,0,1,1-4.011,4.119,3.916,3.916,0,0,1,4.011-4.119m0,1.063a3.07,3.07,0,1,0,2.782,3.056,2.787,2.787,0,0,0-2.782-3.056",
    transform: "translate(-252.248 -228.171)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1243",
    "data-name": "Caminho 1243",
    d: "M395.9,325.657l-4.405-6.112v6.112H390.3v-7.963h1.23l4.334,5.969v-5.969h1.194v7.963Z",
    transform: "translate(-280.728 -228.507)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1244",
    "data-name": "Caminho 1244",
    d: "M238.588,60.287l10.617-10.617-8.8-8.788-3.535,3.535-1.825-1.825,3.539-3.539-3.539-3.539,1.825-1.825,3.544,3.544,5.254-5.253-5.258-5.258-3.539,3.539-1.82-1.821,5.364-5.364,8.189,8.189V41.992l-4.647-4.648-1.714,1.714,8.788,8.792,0-17.592L240.413,19.642l-8.788,8.8,3.535,3.535L233.334,33.8l-3.539-3.539L226.256,33.8l-1.825-1.825,3.543-3.543-5.253-5.254-5.258,5.258L221,31.973l-1.821,1.821-5.364-5.364,8.189-8.188h10.729l-4.647,4.647L229.8,26.6l8.792-8.788-17.592,0L210.385,28.434l8.8,8.788,3.535-3.535,1.825,1.825L221,39.052l3.539,3.539-1.825,1.825-3.543-3.544-5.254,5.253,5.258,5.258,3.539-3.539,1.821,1.821-5.364,5.364-8.188-8.189V36.112l4.647,4.647,1.714-1.714-8.788-8.792,0,17.591,10.617,10.617,8.788-8.8-3.535-3.535,1.825-1.825,3.539,3.539,3.539-3.539,1.825,1.825-3.543,3.544,5.253,5.253,5.258-5.258-3.539-3.539,1.821-1.821,5.364,5.364-8.188,8.188H226.855l4.647-4.647L229.788,51.5,221,60.287l0,0Zm1.825-30.138,1.829,1.83L240.417,33.8l-1.829-1.83Zm-19.521-1.714,1.83-1.83,1.825,1.825-1.83,1.83Zm-1.714,19.521-1.829-1.83,1.825-1.825L221,46.13Zm10.618-14.268,1.825,1.825-1.825,1.825-1.825-1.825Zm-3.539,7.189-1.825-1.825,1.825-1.825,1.825,1.825Zm3.539,3.539-1.825-1.825,1.825-1.825,1.825,1.825Zm1.714-5.364,1.825-1.825,1.825,1.825-1.825,1.825ZM238.7,49.669l-1.829,1.83-1.825-1.825,1.829-1.83Z",
    transform: "translate(-150.009 -12.814)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1245",
    "data-name": "Caminho 1245",
    d: "M243.219,15.371,227.849,0H206.113l-15.37,15.37V37.107l15.37,15.37h21.736l15.37-15.37ZM240.795,36.1l-13.95,13.95H207.117L193.167,36.1V16.375l13.95-13.95h19.728l13.95,13.95Z",
    transform: "translate(-137.195 -0.001)",
    fill: "#1d1d1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionDark);
export default __webpack_public_path__ + "static/media/nutrition-dark.563ec698fa50b3477f91536d99211407.svg";
export { ForwardRef as ReactComponent };